export default "__VITE_ASSET__BzNKCnHh__"